import { useSite } from "@/context/SiteContext";
import { Kicker, Reveal } from "@/components/Reveal";

const imagePositions = ["34% 50%", "48% 50%", "42% 50%", "34% 50%", "56% 50%", "58% 50%"];

export const Research = () => {
    const { t } = useSite();
    return (
        <section id="research" data-testid="research-section" className="mesh-blue relative z-10 -mt-8 overflow-hidden rounded-t-[2rem] text-white sm:rounded-t-[3rem]">
            <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12 lg:py-40">
                <Reveal>
                    <Kicker light>{t.research.kicker}</Kicker>
                    <h2 className="headline-section mt-6 font-display font-semibold" data-testid="research-heading">
                        {t.research.heading}
                    </h2>
                </Reveal>

                <div className="mt-16 hidden lg:flex lg:h-[600px] lg:gap-3">
                    {t.research.items.map((item, i) => (
                        <article
                            key={item.name}
                            tabIndex={0}
                            aria-label={item.name}
                            data-testid={`research-item-${i}`}
                            className="group relative min-w-0 flex-1 overflow-hidden rounded-2xl border border-white/10 transition-[flex-grow] duration-700 ease-out hover:grow-[2.8] focus:grow-[2.8] focus:outline-none focus-visible:ring-2 focus-visible:ring-chitta-sky"
                        >
                            <img
                                src={item.img}
                                alt={item.alt}
                                loading="lazy"
                                width="1200"
                                height="800"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                style={{ objectPosition: imagePositions[i] }}
                            />
                            <div
                                aria-hidden="true"
                                className="absolute inset-0"
                                style={{ background: "linear-gradient(to top, rgba(2,11,29,0.92) 0%, rgba(7,48,119,0.35) 55%, rgba(7,48,119,0.15) 100%)" }}
                            />
                            <div className="absolute inset-x-0 bottom-0 p-6">
                                <span aria-hidden="true" className="font-display text-base font-medium tracking-[0.2em] text-chitta-sky">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-3 min-h-[2.7em] font-display text-2xl font-semibold leading-tight tracking-tight">
                                    {item.name}
                                </h3>
                                <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-out group-hover:grid-rows-[1fr] group-focus:grid-rows-[1fr]">
                                    <p className="mt-3 max-w-[40ch] overflow-hidden text-sm leading-[1.75] text-white/80 opacity-0 transition-opacity duration-500 group-hover:opacity-100 group-focus:opacity-100">
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="mt-14 flex flex-col gap-12 lg:hidden">
                    {t.research.items.map((item, i) => (
                        <article key={item.name} data-testid={`research-item-m-${i}`} className={i > 0 ? "border-t border-white/10 pt-10" : ""}>
                            <Reveal>
                                <div className="overflow-hidden rounded-2xl">
                                    <img
                                        src={item.img}
                                        alt={item.alt}
                                        loading="lazy"
                                        width="1200"
                                        height="800"
                                        className="aspect-[16/10] w-full object-cover"
                                        style={{ objectPosition: imagePositions[i] }}
                                    />
                                </div>
                                <span aria-hidden="true" className="mt-5 block font-display text-base font-medium tracking-[0.2em] text-chitta-sky">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-3 font-display text-3xl font-semibold tracking-tight">{item.name}</h3>
                                <p className="mt-3 max-w-[46ch] text-lg leading-[1.8] text-white/75">{item.desc}</p>
                            </Reveal>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
